module.exports = __webpack_public_path__ + "static/media/IIIBDS.a7188418.pdf";